import { MediaController } from 'media-chrome/react';
import React, { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';

import { SimpleImage } from './image-simple.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/media.d.ts').Video}
 */
const Video = ({
    autoPlay = false,
    embed,
    height,
    loop = false,
    muted = false,
    poster,
    controls = true,
    src,
    title = '',
    width
}) => {
    const playerRef = useRef(null);

    const [hasWindow, setHasWindow] = useState(false);
    const [isPlaying, setIsPlaying] = useState(autoPlay);
    const [showPoster, setShowPoster] = useState(true);

    const play = () => {
        setIsPlaying(true);
    };

    const stop = () => {
        setIsPlaying(false);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setHasWindow(true);
        }
    }, []);

    useEffect(() => {
        setShowPoster(!isPlaying);
    }, [isPlaying]);

    const posterImage = (
        <SimpleImage
            className='h-full w-full object-contain object-center'
            src={poster || embed?.thumbnailUrl || undefined } />
    );

    return (
        <MediaController
            style={{
                aspectRatio: (width && height) ? `${width}/${height}` : '16/9',
                height: '100%',
                objectFit: 'contain',
                objectPosition: 'center',
                overflow: 'hidden',
                width: '100%'
            }}>
            {hasWindow && (
                <ReactPlayer
                    crossorigin
                    controls={controls}
                    light={(autoPlay || !showPoster) ? false : posterImage}
                    loop={loop}
                    muted={muted}
                    onEnded={() => stop()}
                    onPlay={() => play()}
                    pip={false}
                    playing={isPlaying}
                    playsInline={true}
                    ref={playerRef}
                    slot='media'
                    src={src}
                    style={{
                        height: '100%',
                        width: '100%'
                    }}
                    title={title}>
                </ReactPlayer>
            )}

            {(showPoster && controls) && (
                <button
                    aria-label='Play video'
                    className='absolute inset-0 h-full w-full horse'
                    onClick={() => play()}
                    type='button'>
                </button>
            )}
        </MediaController>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default Video;
